import styled from "styled-components";

import { text } from "@ui/helpers";

export const Root = styled.div`
  ${text("medium_18")}
  color: ${({ theme }) => theme.palette.white};
`;

export const CustomLabel = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.spacing_4};
  align-items: center;
`;
